var map = {
	"./amazed.gif": "65b5",
	"./angry.gif": "488d",
	"./applaud.gif": "8ec9",
	"./arrogance.gif": "c891",
	"./awkward.gif": "99c9",
	"./basketball.gif": "cb36",
	"./beer.gif": "982a",
	"./blessing.gif": "1f7b",
	"./bomb.gif": "d413",
	"./cake.gif": "ef30",
	"./cattiness.gif": "e8d6",
	"./coffee.gif": "7802",
	"./cold-sweat.gif": "5081",
	"./complacent.gif": "24c7",
	"./concerned.gif": "a8bc",
	"./contempt.gif": "165e",
	"./cool.gif": "ea13",
	"./crazy.gif": "1ee2",
	"./cry.gif": "955b",
	"./daze.gif": "e01b",
	"./disappointing.gif": "e437",
	"./doubt.gif": "ed2c",
	"./embarrassing.gif": "4861",
	"./excite.gif": "5514",
	"./facepalm.gif": "a632",
	"./fade.gif": "19b7",
	"./faint.gif": "d4a0",
	"./fast-cry.gif": "6724",
	"./fist.gif": "1b5e",
	"./flurry.gif": "bb68",
	"./flushed.gif": "ae09",
	"./football.gif": "6cd0",
	"./fuels.gif": "52d0",
	"./ghost.gif": "9074",
	"./gift.gif": "143a",
	"./gifts.gif": "f23c",
	"./goodbye.gif": "1e8f",
	"./grievance.gif": "4b82",
	"./handshake.gif": "1567",
	"./heart-broken.gif": "8d99",
	"./heart.gif": "2ce1",
	"./hey.gif": "aa9b",
	"./hug.gif": "9caa",
	"./hunger.gif": "ef54",
	"./hush.gif": "d8bb",
	"./joy.gif": "5bde",
	"./jump.gif": "df7a",
	"./kiss-offering.gif": "24fe",
	"./kiss.gif": "6d16",
	"./kitchen-knife.gif": "a68a",
	"./knife.gif": "8fb64",
	"./kowtow.gif": "245d",
	"./ladybird.gif": "f5c6",
	"./left-hem.gif": "5b1d",
	"./left-tai-chi.gif": "decc",
	"./leisure.gif": "23b4",
	"./lewd.gif": "9726",
	"./lightning.gif": "9fb2",
	"./lip.gif": "f386",
	"./look-back.gif": "e4be",
	"./love-you.gif": "2a6a",
	"./love.gif": "cbcc",
	"./mad.gif": "20e4",
	"./mask.gif": "9fcb",
	"./meal.gif": "8fd8",
	"./moon.gif": "9d5e",
	"./muscle.gif": "a97a",
	"./naughty.gif": "5d6f",
	"./no.gif": "aef0",
	"./ok.gif": "356e",
	"./packet.gif": "126a",
	"./pensive.gif": "3d6a",
	"./pick-nose.gif": "45db",
	"./pie-mouth.gif": "e0d5",
	"./pig.gif": "a8a0",
	"./ping-pong.gif": "e008",
	"./pitiful.gif": "044e",
	"./pleasant.gif": "ddd4",
	"./potbellied.gif": "495a",
	"./pray.gif": "8170",
	"./right-hem.gif": "ad65",
	"./right-tai-chi.gif": "6996",
	"./rope-skipping.gif": "a6ec",
	"./rose.gif": "97c9",
	"./scare.gif": "cfc2",
	"./scream.gif": "b2b4",
	"./seduce.gif": "eb08",
	"./shiver.gif": "7a83",
	"./shut-up.gif": "5c16",
	"./shy.gif": "18d6",
	"./simper.gif": "7214",
	"./skeleton.gif": "e124",
	"./sleeping.gif": "798e",
	"./smart.gif": "c61c",
	"./smile.gif": "8d47",
	"./smiles.gif": "5d87",
	"./smirk.gif": "68e8",
	"./snag.gif": "8fce",
	"./snicker.gif": "63ad",
	"./sorrow.gif": "ad16",
	"./sorry.gif": "098d",
	"./spit.gif": "7470",
	"./strike.gif": "7a19",
	"./strive.gif": "02cd",
	"./strong.gif": "6286",
	"./stuck_out_tongue_closed_eyes.gif": "22a7",
	"./sulking.gif": "389a",
	"./sun.gif": "6caa",
	"./supercilious-look.gif": "9056",
	"./surrender.gif": "0d28",
	"./swear.gif": "a003",
	"./sweat.gif": "503d",
	"./tada.gif": "2db4",
	"./tears.gif": "47e8",
	"./terrified.gif": "634c",
	"./throw-kiss.gif": "c427",
	"./tired.gif": "5b47",
	"./titter.gif": "3653",
	"./unamused.gif": "ea86",
	"./victory.gif": "878b",
	"./watermelon.gif": "641a",
	"./weak.gif": "0bca",
	"./whirl.gif": "cdae",
	"./wipe-perspiration.gif": "f75b",
	"./yawn.gif": "02dc",
	"./yeah.gif": "dc96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e0b";